module.exports = __webpack_public_path__ + "img/symbol_0.c33b41d5.png";